import React from "react";

import { Grid } from "@mui/material";
import { Skeleton, Stack } from "@mui/material";

const DespatchViewSkeleton = () => {
  const heightInput = 60;

  return (
    <Grid container direction="row" spacing={2}>
      <Grid item xs={6}>
        <Stack spacing={2}>
          <Stack direction="row" spacing={2}>
            <Skeleton variant="text" width="100%" height={heightInput} />
          </Stack>
          <Stack direction="row" spacing={2}>
            <Skeleton variant="text" width="100%" height={heightInput} />
          </Stack>
          <Skeleton variant="text" width="100%" height={heightInput} />
          <Stack direction="row" spacing={2}>
            <Skeleton variant="text" width="100%" height={heightInput} />
          </Stack>
        </Stack>
      </Grid>
      <Grid item xs={6}>
        <Stack spacing={2}>
          <Stack direction="row" spacing={2}>
            <Skeleton variant="text" width="100%" height={heightInput} />
          </Stack>
          <Stack direction="row" spacing={2}>
            <Skeleton variant="text" width="100%" height={heightInput} />
          </Stack>
          <Skeleton variant="text" width="100%" height={heightInput} />
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant="rectangular" width="100%" height="400px" />
      </Grid>
    </Grid>
  );
};

export default DespatchViewSkeleton;
